import React from "react";
import { Box } from "@mui/system";
import { RootElementEditor } from "./Editors/RootElementEditor";
import { UILabel } from "../CommonUI/BuildlingBlocks/UILabel";
import { ObserveState } from "../CommonUI/StateManagement/ObserveState";
import { Grid } from "@mui/material";
import { TextMergeEditContext } from "../rule-engine-core/TextMerge/TextMergeEditContext";
import { UIStyleConstants } from "../rule-engine-core/Common/UIStyleConstants";

export function TextMergeBuilderInternal(props: { editContext: TextMergeEditContext }) {
    let rootEditor = new RootElementEditor();
    rootEditor.editorData = props.editContext.definition.rootElement;

    return (
        <ObserveState
            control={() => {
                return (
                    <Grid
                        direction={"row"}
                        padding={"5px"}
                        container={true}
                        spacing={1}
                        width={"100%"}
                        columns={9}
                    >
                        <Grid
                            xs={3}
                            item={true}
                        >
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                {rootEditor.renderEditor(props.editContext.definition.rootElement, props.editContext)}
                            </Box>
                        </Grid>
                        <Grid
                            xs={6}
                            item={true}
                        >
                            <UILabel>Preview</UILabel>
                            <Box
                                height={"100%"}
                                padding={"10px"}
                                marginTop={"5px"}
                                border={"1px solid " + UIStyleConstants.GRAY_DARK_COLOR}
                            >
                                <ObserveState
                                    key={"preview"}
                                    listenTo={props.editContext.definition.rootElement}
                                    control={() => {
                                        return rootEditor.renderDisplay(
                                            props.editContext.definition.rootElement,
                                            props.editContext,
                                        );
                                    }}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                );
            }}
            listenTo={props.editContext}
            properties={["selectedElement"]}
        />
    );
}
